import React, { Component } from 'react';
import history from './History';
import './Login.css'

class Login extends Component {

  constructor(props) {
    super(props);
    this.state = { isLoginOpen: true, isRegisterOpen: false, email: '', isVerify: false };
    this.setParams = this.setParams.bind(this);
  }

  setParams(s) {
    this.setState({ isLoginOpen: !s.isRegisterOpen, isRegisterOpen: s.isRegisterOpen, email: s.email, isVerify: s.isVerify })
  }

  showLoginBox() {
    this.setState({isRegisterOpen: false, isLoginOpen: true});
  }

  showRegisterBox() {
    this.setState({isRegisterOpen: true, isLoginOpen: false});
  }

  render() {
    return (
      <div className="root-container">
        
        <div className="box-controller">
          <div className={"controller" + (this.state.isLoginOpen ? " selected-controller" : "")} onClick={this.showLoginBox.bind(this)}>
            Sign In
          </div>
          <div className={"controller" + (this.state.isRegisterOpen ? " selected-controller" : "")} onClick={this.showRegisterBox.bind(this)}>
            Register
          </div>
        </div>

        <div className="box-container">
          {this.state.isLoginOpen && 
            <LoginBox setParams={this.setParams} email={this.state.email} 
            setLoggedInFlag={this.props.setLoggedInFlag}/>}
          {this.state.isRegisterOpen && 
            <RegisterBox setParams={this.setParams} isVerify={this.state.isVerify} email={this.state.email}/>}
        </div>
        
      </div>
    );
  }
}

class LoginBox extends Component {
  constructor(props) {
    super(props);
    this.state = { email: props.email, password: "", errors: [] };
  }

  showValidationErr(elm, msg) {
    this.setState((prevState) => ( { errors: [...prevState.errors, { elm, msg }] } ))
  } 

  clearValidationErr(elm) {
    let newArr = [];
    this.setState((prevState) => {
      for (let err of prevState.errors) {
        if (elm !== err.elm && "login" !== err.elm) {
          newArr.push(err);
        }
      }
      return { email: prevState.email, password: prevState.password, errors: newArr };
    });
  }
  
  onEmailChange(e) {
    this.setState({ email: e.target.value });
    this.clearValidationErr("email");
  }

  onPasswordChange(e) {
    this.setState({ password: e.target.value });
    this.clearValidationErr("password");
  }

  submitLogin(e) {
    let isErr = false;
    if (this.state.email === "") {
      this.showValidationErr("email", "Email cannot be empty!");
      isErr = true;
    } 
    if (this.state.password === "") {
      this.showValidationErr("password", "Password cannot be empty!");
      isErr = true;
    }
    if (isErr) return;

    fetch('https://delta.megadigm.com:2191/session/login', {
      credentials: 'include',
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/text'
      },
      body: "_uid=" + this.state.email + "&_pwd=" + this.state.password
    }).then(res => {
      if (res.ok && document.cookie) {
        this.props.setLoggedInFlag();
        // send user to product page after successful login:
        // history.push("/product");
        return "success";
      } else {
        return res.json();
      }        
    }).then(data => {
      if (data !== "success") {
        let errMsg = data.detailedErrorMessage.replace("_uid value", "email").replace("_pwd value", "password");
        this.setState((prevState) => ( { errors: [...prevState.errors, { elm: "login", msg: errMsg }] } ));
        if (errMsg.search(/account\s.*\snot\s.*\sverified/i) !== -1)
          history.push("/login", this.props.setParams({email: this.state.email, isRegisterOpen: true, isVerify: true}));
      }
    }).catch((error) => {
      console.log(error);
      this.setState((prevState) => ( { errors: [...prevState.errors, { elm: "login", msg: "Login failed" }] } ))
    });
  }

  render() {
    let emailErr = null, passwordErr = null, submitErr = null;
    for (let err of this.state.errors) {
      if (err.elm === "email") {
        emailErr = err.msg;
      } else if (err.elm === "password") {
        passwordErr = err.msg;
      } else if (err.elm === "login") {
        submitErr = err.msg;
      }
    }

    return (
      <div className="inner-container">
        <div className="header">Sign In</div>
        <div className="box">
          <div className="input-group">
            <label htmlFor="email" className="input-label">Email / UID</label>
            <input type="text" name="email" className="login-input" placeholder="Email / UID" value={this.state.email} onChange={(e) => this.onEmailChange(e)} />
            <small className="danger-error">{ emailErr ? emailErr : "" }</small>
          </div>
          <div className="input-group">
            <label htmlFor="password" className="input-label">Password</label>
            <input type="password" name="password" className="login-input" placeholder="Password" onChange={this.onPasswordChange.bind(this)}/>
            <small className="danger-error">{ passwordErr ? passwordErr : "" }</small>
          </div>
          <div className="submit-group">
            <button type="button" className="submit-btn" onClick={this.submitLogin.bind(this)}>Sign In</button>
            <small className="danger-error">{ submitErr ? submitErr : "" }</small>
          </div>
        </div>
      </div>
    );
  } 
}

class RegisterBox extends Component {
  constructor(props) {
    super(props);
    this.state = { isVerify: props.isVerify, email: props.email, password: "", vericode: "", errors: [] };
  }

  showValidationErr(elm, msg) {
    this.setState((prevState) => ( { errors: [...prevState.errors, { elm, msg }] } ))
  } 

  clearValidationErr(elm) {
    let newArr = [];
    this.setState((prevState) => {
      for (let err of prevState.errors) {
        if (elm !== err.elm && "submit" !== err.elm) {
          newArr.push(err);
        }
      }
      return { isVerify: prevState.isVerify, email: prevState.email, password: prevState.password, vericode: prevState.vericode, errors: newArr };
    });
  }
  
  onEmailChange(e) {
    this.setState({ email: e.target.value });
    this.clearValidationErr("email");
  }

  onPasswordChange(e) {
    this.setState({ password: e.target.value });
    this.clearValidationErr("password");
  }

  onVericodeChange(e) {
    this.setState({ vericode: e.target.value })
    this.clearValidationErr("vericode")
  }

  submitRegister(e) {
    let isErr = false;
    if (this.state.isVerify) {
        if (this.state.vericode === "") { this.showValidationErr("vericode", "Verification code cannot be empty!");
        isErr = true;
      }
    } else {
      if (this.state.email === "") {
        this.showValidationErr("email", "Email cannot be empty!");
        isErr = true;
      } else if (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(this.state.email) === false) {
        this.showValidationErr("email", "Email is invalid!");
        isErr = true;
      }
      let isPwdErr = false;
      if (this.state.password === "") {
        this.showValidationErr("password", "Password cannot be empty!");
        isPwdErr = true;
      } else {
        let errMsg = "Missing at least:";
        if (/^(?=.*[a-z])/.test(this.state.password) === false) {
          errMsg += " 1 lower case char,";
          isPwdErr = true;
        }
        if (/^(?=.*[A-Z])/.test(this.state.password) === false) {
          errMsg += " 1 upper case char,";
          isPwdErr = true;
        }
        if (/^(?=.*[0-9])/.test(this.state.password) === false) {
          errMsg += " 1 number,";
          isPwdErr = true;
        }
        if (/^(?=.*[!@#$%^&*])/.test(this.state.password) === false) {
          errMsg += " 1 of !@#$%^&*,";
          isPwdErr = true;
        }
        let missLen = 8 - this.state.password.length;
        if (missLen > 0) {
          errMsg += " " + missLen + " more char" + (missLen > 1 ? "s," : ",");
          isPwdErr = true;
        }

        if (isPwdErr) {
          this.showValidationErr("password", errMsg.substr(0, errMsg.length - 1));
          isErr = true;
        }
      }
    }
    if (isErr) return;

    fetch('https://delta.megadigm.com:2191/account', {
      credentials: 'include',
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/text'
      },
      body: this.state.isVerify ? 
      '_rqt={"action":"VERIFY","data":{"email":"' + this.state.email + '","verificationCode":"' + this.state.vericode + '"}}' :
      '_rqt={"action":"ADD","data":{"email":"' + this.state.email + '","pwd":"' + this.state.password + '"}}'
    }).then(res => {
      if (res.ok) {
        this.setState((prevState) => ({ isVerify : !prevState.isVerify }));
        if (!this.state.isVerify) {
          // send to Login page after new account is verified successfully:
          history.push("/login", this.props.setParams({email: this.state.email, isRegisterOpen: false, isVerify: false}));
        }
        return "success";
      } else {
        return res.json();
      }        
    }).then(data => {
      if (data !== "success") {
        let errMsg = data.detailedErrorMessage
        this.setState((prevState) => ( { errors: [...prevState.errors, { elm: "submit", msg: errMsg }] } ))
      }
    }).catch((error) => {
      this.setState((prevState) => ( { errors: [...prevState.errors, { elm: "submit", msg: "Registration failed" }] } ))
    });
  }

  render() {
    let emailErr = null, passwordErr = null, vericodeErr = null, submitErr = null;
    for (let err of this.state.errors) {
      if (err.elm === "email") {
        emailErr = err.msg;
      } else if (err.elm === "vericode") {
        vericodeErr = err.msg;
      } else if (err.elm === "password") {
        passwordErr = err.msg;
      } else if (err.elm === "submit") {
        submitErr = err.msg;
      }
    }

    return (
      <div className="inner-container">
        <div className="header">Register</div>
        <div className="box">
          <div className="input-group">
            <label htmlFor="email" className="input-label">Email</label>
            <input type="text" name="email" className="login-input" placeholder="Email" value={this.state.email}
              disabled = {(this.state.isVerify) ? "disabled" : ""} onChange={(e) => this.onEmailChange(e)} />
            <small className="danger-error">{ emailErr ? emailErr : "" }</small>
          </div>
          <div className="input-group">
            <label htmlFor="password" className="input-label">Password</label>
            <input type="password" name="password" className="login-input" placeholder="Password"
              disabled = {(this.state.isVerify) ? "disabled" : ""} onChange={this.onPasswordChange.bind(this)} />
            <small className="danger-error">{ passwordErr ? passwordErr : "" }</small>
          </div>
          <div className="submit-group" hidden={!this.state.isVerify}>
            <label htmlFor="Verification Code" className="input-label"
              disabled = {(this.state.isVerify) ? "" : "disabled"}>Verification Code</label>
            <small className="notice-msg"
              disabled = {(this.state.isVerify) ? "" : "disabled"}>{'(emailed to ' + this.state.email + ')'}</small>
            <input type="text" name="vericode" className="verify-input" autoComplete="off"
              disabled = {(this.state.isVerify) ? "" : "disabled"} onChange={this.onVericodeChange.bind(this)} />
            <small className="danger-error">{ vericodeErr ? vericodeErr : "" }</small>
          </div>
          <div className="submit-group">
            <button type="button" className="submit-btn" onClick={this.submitRegister.bind(this)}>
              { this.state.isVerify ? 'Verify' : 'Register' }
            </button>
            <small className="danger-error">{ submitErr ? submitErr : "" }</small>
          </div>
        </div>
      </div>
    );
  }
}

export default Login;